<template>
  <section class="overflow-hidden" data-component="c navigation">
    <nav class="fixed z-10 w-full text-gin8-gold">
      <div
        class="grid lg:grid-cols-10 nav-container"
        :class="this.scroll ? 'bg-gin8-green' : ''"
      >
        <div class="col-span-1 pl-2 text-left">
          <a @click="scrollToTop">
            <svg
              class="inline-block w-32 h-16 fill-current lg:w-40 lg:h-20"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 100 70"
            >
              <path
                id="GIN8"
                d="M27.5549032,35.1540741 C27.5549032,39.9988889 26.8076516,42.8211111 24.3790839,45.3611111 C21.6235935,48.2774074 18.5411806,49.1711111 14.9917355,49.1711111 C11.2087742,49.1711111 8.40658065,47.9011111 6.11812258,45.6433333 C2.80219355,42.3037037 2.75549032,38.5407407 2.75549032,32.1437037 C2.75549032,25.7466667 2.80219355,21.9837037 6.11812258,18.6440741 C8.40658065,16.3862963 11.2087742,15.1162963 14.9917355,15.1162963 C22.744471,15.1162963 26.6208387,20.1962963 27.5082,25.8407407 L20.9697484,25.8407407 C20.2224968,22.6422222 18.3076645,20.9488889 14.9917355,20.9488889 C13.2170129,20.9488889 11.8159161,21.6544444 10.8351484,22.7362963 C9.62086452,24.1474074 9.24723871,25.7466667 9.24723871,32.1437037 C9.24723871,38.5407407 9.62086452,40.187037 10.8351484,41.5981481 C11.8159161,42.68 13.2170129,43.3385185 14.9917355,43.3385185 C16.9999742,43.3385185 18.5878839,42.632963 19.6153548,41.457037 C20.689529,40.2340741 21.1098581,38.7288889 21.1098581,36.9885185 L21.1098581,35.7655556 L14.9917355,35.7655556 L14.9917355,30.2622222 L27.5549032,30.2622222 L27.5549032,35.1540741 Z M40.6785097,48.8888889 L34.1867613,48.8888889 L34.1867613,15.3985185 L40.6785097,15.3985185 L40.6785097,48.8888889 Z M73.8845032,48.8888889 L68.0933032,48.8888889 L54.9229935,28.3337037 L54.9229935,48.8888889 L48.4312452,48.8888889 L48.4312452,15.3985185 L54.2224452,15.3985185 L67.3927548,35.9066667 L67.3927548,15.3985185 L73.8845032,15.3985185 L73.8845032,48.8888889 Z M111.947632,39.1522222 C111.947632,45.6433333 107.183903,49.1711111 101.299297,49.1711111 C95.4146903,49.1711111 90.6509613,45.6433333 90.6509613,39.1522222 C90.6509613,35.06 92.9861226,32.8492593 94.8075484,31.6262963 C93.1262323,30.4503704 91.0712903,28.2396296 91.0712903,24.6648148 C91.0712903,18.7381481 95.7416129,15.1162963 101.299297,15.1162963 C106.856981,15.1162963 111.4806,18.7381481 111.4806,24.6648148 C111.4806,28.2396296 109.425658,30.4503704 107.744342,31.6262963 C109.565768,32.8492593 111.947632,35.06 111.947632,39.1522222 Z M105.876213,39.0581481 C105.876213,36.4711111 103.867974,34.4014815 101.299297,34.4014815 C98.7306194,34.4014815 96.7223806,36.4711111 96.7223806,39.0581481 C96.7223806,41.6451852 98.7306194,43.6677778 101.299297,43.6677778 C103.867974,43.6677778 105.876213,41.6451852 105.876213,39.0581481 Z M105.409181,24.852963 C105.409181,22.4540741 103.681161,20.6196296 101.299297,20.6196296 C98.9174323,20.6196296 97.1427097,22.4540741 97.1427097,24.852963 C97.1427097,27.2988889 98.9174323,29.0862963 101.299297,29.0862963 C103.681161,29.0862963 105.409181,27.2988889 105.409181,24.852963 Z"
              />
            </svg>
          </a>
        </div>
        <div class="hidden col-span-7 pt-6 text-center lg:block">
          <a
            v-for="(navitem, i) in Navitems"
            :id="navitem.url.slice(1) + '-nav'"
            :key=" i"
            v-scroll-to="navitem.url"
            class="relative px-8 py-3 cursor-pointer navitem"
          >
            {{ navitem.name }}
          </a>
        </div>
        <div class="lg:hidden">
          <button
            class="menu-item hamburger hide-for-large text-gin8-gold"
            :class="{ 'is-active': menuOpen }"
            @click="toggleMenu"
          >
            <span class="hamburger-span is-1" />
            <span class="hamburger-span is-2" />
            <span class="hamburger-span is-3" />
          </button>
          <div ref="mobileMenu" class="menu-mobile bg-gin8-green text-24px" :class="{ 'mobile-is-open': menuOpen }">
            <svg
              class="inline-block w-32 h-16 pl-4 fill-current lg:w-40 lg:h-20"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 100 70"
            >
              <path
                id="GIN8"
                d="M27.5549032,35.1540741 C27.5549032,39.9988889 26.8076516,42.8211111 24.3790839,45.3611111 C21.6235935,48.2774074 18.5411806,49.1711111 14.9917355,49.1711111 C11.2087742,49.1711111 8.40658065,47.9011111 6.11812258,45.6433333 C2.80219355,42.3037037 2.75549032,38.5407407 2.75549032,32.1437037 C2.75549032,25.7466667 2.80219355,21.9837037 6.11812258,18.6440741 C8.40658065,16.3862963 11.2087742,15.1162963 14.9917355,15.1162963 C22.744471,15.1162963 26.6208387,20.1962963 27.5082,25.8407407 L20.9697484,25.8407407 C20.2224968,22.6422222 18.3076645,20.9488889 14.9917355,20.9488889 C13.2170129,20.9488889 11.8159161,21.6544444 10.8351484,22.7362963 C9.62086452,24.1474074 9.24723871,25.7466667 9.24723871,32.1437037 C9.24723871,38.5407407 9.62086452,40.187037 10.8351484,41.5981481 C11.8159161,42.68 13.2170129,43.3385185 14.9917355,43.3385185 C16.9999742,43.3385185 18.5878839,42.632963 19.6153548,41.457037 C20.689529,40.2340741 21.1098581,38.7288889 21.1098581,36.9885185 L21.1098581,35.7655556 L14.9917355,35.7655556 L14.9917355,30.2622222 L27.5549032,30.2622222 L27.5549032,35.1540741 Z M40.6785097,48.8888889 L34.1867613,48.8888889 L34.1867613,15.3985185 L40.6785097,15.3985185 L40.6785097,48.8888889 Z M73.8845032,48.8888889 L68.0933032,48.8888889 L54.9229935,28.3337037 L54.9229935,48.8888889 L48.4312452,48.8888889 L48.4312452,15.3985185 L54.2224452,15.3985185 L67.3927548,35.9066667 L67.3927548,15.3985185 L73.8845032,15.3985185 L73.8845032,48.8888889 Z M111.947632,39.1522222 C111.947632,45.6433333 107.183903,49.1711111 101.299297,49.1711111 C95.4146903,49.1711111 90.6509613,45.6433333 90.6509613,39.1522222 C90.6509613,35.06 92.9861226,32.8492593 94.8075484,31.6262963 C93.1262323,30.4503704 91.0712903,28.2396296 91.0712903,24.6648148 C91.0712903,18.7381481 95.7416129,15.1162963 101.299297,15.1162963 C106.856981,15.1162963 111.4806,18.7381481 111.4806,24.6648148 C111.4806,28.2396296 109.425658,30.4503704 107.744342,31.6262963 C109.565768,32.8492593 111.947632,35.06 111.947632,39.1522222 Z M105.876213,39.0581481 C105.876213,36.4711111 103.867974,34.4014815 101.299297,34.4014815 C98.7306194,34.4014815 96.7223806,36.4711111 96.7223806,39.0581481 C96.7223806,41.6451852 98.7306194,43.6677778 101.299297,43.6677778 C103.867974,43.6677778 105.876213,41.6451852 105.876213,39.0581481 Z M105.409181,24.852963 C105.409181,22.4540741 103.681161,20.6196296 101.299297,20.6196296 C98.9174323,20.6196296 97.1427097,22.4540741 97.1427097,24.852963 C97.1427097,27.2988889 98.9174323,29.0862963 101.299297,29.0862963 C103.681161,29.0862963 105.409181,27.2988889 105.409181,24.852963 Z"
              />
            </svg>
            <div class="mobile-menu-items">
              <a
                v-for="(navitem, i) in Navitems"
                :key=" i"
                v-scroll-to="navitem.url"
                class="px-8 py-3 cursor-pointer full-opaque mobile-menu-item"
                @click="toggleMenu"
              >
                {{ navitem.name }}
              </a>
              <a
                v-scroll-to="Navitems[4].url"
                class="px-8 py-2 mx-auto rounded-full mobile-menu-item max-w-260px full-opaque orderButton text-gin8-green bg-gin8-gold"
                @click="toggleMenu"
              >
                Jetzt vorbestellen
              </a>
            </div>
          </div>
        </div>
        <div class="hidden col-span-2 pt-6 pr-10 text-right lg:block">
          <a
            v-scroll-to="Navitems[4].url"
            class="px-8 py-2 rounded-full cursor-pointer max-w-260px orderButton text-gin8-green bg-gin8-gold"
          >
            Jetzt bestellen
          </a>
        </div>
      </div>
    </nav>
  </section>
</template>

<script>
import Navitems from '../../config/mainNavItems';

export default {
  name: 'CNavigation',
  components: {},
  data() {
    return {
      Navitems,
      scroll: false,
      menuOpen: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', () => {
      if (window.pageYOffset > 5) {
        this.scroll = true;
      } else {
        this.scroll = false;
      }
    });
  },
  destroyed() {
    window.removeEventListener('scroll', () => false);
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
      document.querySelectorAll('.mobile-menu-item').forEach((e) => {
        e.classList.remove('full-opaque');
      });
      document.querySelectorAll('.mobile-menu-item').forEach((e) => {
        e.classList.add('fade-in-opacity');
      });
    },
  },
};
</script>
<style>
.menu-mobile{
  display: none;
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
}

.menu-mobile.mobile-is-open{
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: center;
}

.hamburger {
  padding-top: 6px;
  position: absolute;
  right: 1rem;
  top: 1rem;
  z-index: 505;
  outline: none;
}

.hamburger:focus, .hamburger:active{
  outline: none;
}

.hamburger-span {
  height: 2.64px;
  border-top: solid 2.64px #fff;
  width: 24px;
  display: block;
  margin-bottom: 4px;
  border-color: rgba(192, 180, 124, var(--text-opacity));
  transition: transform 500ms cubic-bezier(0.2, 0.8, 0.2, 1);
}

.hamburger.is-active .is-1 {
  transform: rotate(45deg) translateY(9px);
  width: 22px;
}

.hamburger.is-active .is-2 {
  visibility: hidden;
}

.hamburger.is-active .is-3 {
  transform: rotate(-45deg) translateY(-9px);
  width: 22px;
}

.is-active {
  position: fixed;
  top: 0.75rem;
  right: 0.5rem;
  width: 24px;
  height: 24px;
}

.orderButton:hover{
  background-color: #b89757;
}

.navitem:hover::before, .navitem.active:before{
  content:'';
  position: absolute;
  background-color: #C0B47C;
  top: 40px;
  width: 20%;
  height: 2px;
  left: 40%
}

.mobile-menu-items{
  margin-top: 100px;
  display: flex;
  flex-direction: column;
}

.full-opaque {
  opacity: 0;
}

.fade-in-opacity {
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: linear;
  animation-duration: 2s;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
}

</style>
